import { VisibilityModesType } from '../../types/visibilityModesType';

export const loadVisibilityStates = (statesList: VisibilityModesType[]) => {
  return {
    type: 'LOAD_VISIBILITY_STATES',
    payload: { statesList },
  };
};
